export enum GradeLevelEnum {
  FIRST_CLASS = 1,
  SECOND_CLASS = 2,
  THIRD_CLASS = 3,
  FOURTH_CLASS = 4,
  KINDER_GARDEN = 99,
}